import { render, staticRenderFns } from "./status.select.vue?vue&type=template&id=99b7d88e"
import script from "./status.select.vue?vue&type=script&lang=js"
export * from "./status.select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports